import { SportName } from '@shared/enums/SportName';
import { getCategoryChild, getLocation, getMatchScores, getSportName, isMatch } from '@shared/utils/eventUtils';

const getCompetitionStageLabel = (event) => event.subStageLabel || event.stageGroupLabel || null;

const getCompetitionStageInfo = (event) => {
	const competitionStageLabel = getCompetitionStageLabel(event);

	if (!competitionStageLabel) {
		return null;
	}

	return {
		label: competitionStageLabel,
	};
};

const getVariant = (event) => {
	const matchScores = getMatchScores(event);
	const hasMatchParticipants = Boolean(matchScores.homeNameFull && matchScores.guestNameFull);

	if (isMatch(event) && event.sport?.name === SportName.VOLLEYBALL) {
		return 'volley';
	}

	if (isMatch(event) && hasMatchParticipants) {
		return 'match';
	}

	return 'single';
};

const getParticipantMeta = (participant) => {
	const participatable = participant?.participatable;
	const teamName = participatable?.team?.name || null;
	const clubName = participatable?.team?.club?.name || participatable?.team?.clubTeamName || null;
	return [teamName, clubName].filter(Boolean).join(' · ') || null;
};

const getParticipants = (event) => {
	return (event.participants || [])
		.map(participant => ({
			id:       participant.id,
			name:     participant.participatable?.name || null,
			imageUrl: participant.participatable?.imageUrl || participant.participatable?.team?.imageUrl || null,
			meta:     getParticipantMeta(participant),
		}))
		.filter(participant => participant.name);
};

const getMetaItems = (event) => {
	const locationName = getLocation(event) || event.venue?.name || null;
	return [
		event.subtitle || null,
		locationName,
	].filter(Boolean);
};

export const EventListItemProps = (event, _options = {}) => {
	const options = {
		hideCompetitionStageInfo: false,
		..._options,
	};
	const variant = getVariant(event);

	return {
		variant,
		title:                event.name || event.title || $I18n.trans('commons.unnamed'),
		subtitle:             variant === 'single' ? null : event.subtitle || null,
		sportLabel:           variant === 'single' ? getSportName(event) : null,
		disciplineLabel:      variant === 'single' ? getCategoryChild(event) : null,
		metaItems:            variant === 'single' ? getMetaItems(event) : [],
		participants:         variant === 'single' ? getParticipants(event) : [],
		unixStart:            event.startTimestamp,
		unixKickoff:          event.startTimestamp + (event.kickoffOffsetMinutes * 60),
		unixEnd:              event.endTimestamp,
		eventType:            event.type,
		link:                 event.externalEventLink || event.url,
		couchModeAvailable:   !!event.couchmodeAvailable && !event.externalEventLink,
		competitionStageInfo: options.hideCompetitionStageInfo ? null : getCompetitionStageInfo(event),
		numberOfPeriods:      getMatchScores(event).scores?.length || 0,
		dashScoreDevider:     window.$arenaConfig.isEuf,
		...getMatchScores(event),
	};
};
